export default function urlHostResolver(input) {
  return `https://${process.env.NEXT_PUBLIC_VERCEL_URL}${input}`;
}
